import React, { useEffect, useState, useRef } from "react";
import Player from "@vimeo/player";
import videoPoster from "../images/video/videoPoster.jpg";

const SiteOverlay = ({ toggleScroll, toggleRevealContent }) => {
  const vid = useRef(null);
  const [hide, toggleHide] = useState(null);

  useEffect(() => {
    const player = new Player(vid.current);

    if (vid != null && player != null) {
      player.play();
    }

    setTimeout(() => {
      toggleHide(!hide);
      toggleScroll(`auto`);
      toggleRevealContent(true);
    }, 6750);

    // when unmounting stop vid
    return () => {
      if (vid != null && player != null) {
        player.destroy();
      }
    };
  }, []);

  return (
    <div className={`site-overlay ${hide ? `hide` : ``}`}>
      <img
        className="site-overlay__video-poster"
        src={videoPoster}
        alt="Full bloom video poster"
      />
      <iframe
        ref={vid}
        className="site-overlay__video"
        src="https://player.vimeo.com/video/558028545?controls=0&muted=1&loop=0&autoplay=1"
        width="640"
        height="360"
        allowFullScreen
        title="Full bloom introduction"
      ></iframe>
    </div>
  );
};

export default SiteOverlay;
